import logEvent from '../logEvent';

const formatFilterStateToggle = (data) => {
  const { filterState } = data;
  return filterState ? 'on' : 'off';
};

// Institution Map - Landing screen

function logEventInstitutionMatcher(code, data) {
  logEvent(`CSM-${code}`, data);
}

export function logEventSearchBarClick() {
  logEventInstitutionMatcher('02');
}

export function logEventEnterSearchText(data) {
  logEventInstitutionMatcher('03', data);
}

export function logEventSearchSuggestionListDisplay() {
  logEventInstitutionMatcher('04');
}

export function logEventSeachSuggestionClick(data) {
  logEventInstitutionMatcher('05', data);
}

export function logEventClearSearchInput(data) {
  logEventInstitutionMatcher('06', data);
}

export function logEventSearchInputMouseEnter() {
  logEventInstitutionMatcher('07');
}

export function logEventSearchInputMouseLeave() {
  logEventInstitutionMatcher('08');
}

export function logEventSearchInputFocused() {
  logEventInstitutionMatcher('09');
}

export function logEventSearchInputBlurred() {
  logEventInstitutionMatcher('10');
}

// Institution Map - Map

export function logEventMapSearchBarDisplay(data) {
  logEventInstitutionMatcher('11', data);
}

export function logEventMapSearchBarClick() {
  logEventInstitutionMatcher('12');
}

export function logEventMapEnterSearchText(data) {
  logEventInstitutionMatcher('13', data);
}

export function logEventMapSearchSuggestionListDisplay() {
  logEventInstitutionMatcher('14');
}

export function logEventMapSearchSuggestionClick(data) {
  logEventInstitutionMatcher('15', data);
}

export function logEventMapClearSearchInput(data) {
  logEventInstitutionMatcher('16', data);
}

export function logEventMapSearchInputMouseEnter() {
  logEventInstitutionMatcher('17');
}

export function logEventMapSearchInputFocused() {
  logEventInstitutionMatcher('18');
}

export function logEventMapSearchInputBlurred() {
  logEventInstitutionMatcher('19');
}

export function logEventMapLoad(data) {
  logEventInstitutionMatcher('20', data);
};

export function logEventMapCareerNameDisplay(data) {
  logEventInstitutionMatcher('21', data);
};

export function logEventMapSalaryRangeDisplay(data) {
  logEventInstitutionMatcher('22', data);
};

export function logEventMapCareerDescriptionDisplay(data) {
  logEventInstitutionMatcher('23', data);
};

export function logEventMapCareerUpdate(data) {
  logEventInstitutionMatcher('24', data);
};

export function logEventMapResultsIndicatorDisplay(data) {
  logEventInstitutionMatcher('25', data);
};

export function logEventMapInstitutionListingDisplay(data) {
  logEventInstitutionMatcher('26', data);
};

export function logEventMapInstitutionHover(data) {
  logEventInstitutionMatcher('27', data);
};

export function logEventMapInstitutionPinHover(data) {
  logEventInstitutionMatcher('30', data);
};

export function logEventMapInstitutionPinFocus(data) {
  logEventInstitutionMatcher('31', data);
};

export function logEventMapInstitutionPinBlur(data) {
  logEventInstitutionMatcher('32', data);
};

export function logEventMapProgramHover(data) {
  logEventInstitutionMatcher('34', data);
};

export function logEventMapLocationClick() {
  logEventInstitutionMatcher('36');
};

export function logEventMapLocationOptionClick(data) {
  logEventInstitutionMatcher('37', data);
};

export function logEventMapLocationPinDisplay(data) {
  logEventInstitutionMatcher('38', data);
};

export function logEventMapProgramDetailsClose(data) {
  logEventInstitutionMatcher('43', data);
};

export function logEventMapShowListButtonClick() {
  logEventInstitutionMatcher('44');
};

export function logEventMapInstitutionListScroll(data) {
  logEventInstitutionMatcher('46', data);
};

export function logEventMapShowMapButtonClick() {
  logEventInstitutionMatcher('47');
};

export function logEventMapInstitutionPinTap(data) {
  logEventInstitutionMatcher('48', data);
};

export function logEventMapProgramBackArrowTap() {
  logEventInstitutionMatcher('50');
};

export function logEventJoinEmbarkPaywall() {
  logEventInstitutionMatcher('52');
};

export function logEventSignInPaywall() {
  logEventInstitutionMatcher('53');
};

export function logEventResultsBackArrowClick(data) {
  logEventInstitutionMatcher('55', data);
};

export function logEventResultsShareClick(data) {
  logEventInstitutionMatcher('56', data);
};

export function logEventResultsDisclaimerClick(data) {
  logEventInstitutionMatcher('57', data);
};

export function logEventResultsContinueExploringClick(data) {
  logEventInstitutionMatcher('58', data);
};

export function logEventResultsNearestSchoolClick(data) {
  logEventInstitutionMatcher('59', data);
};

export function logEventResultsHighestTuitionClick(data) {
  logEventInstitutionMatcher('60', data);
};

export function logEventResultsTopProgramClick(data) {
  logEventInstitutionMatcher('61', data);
};

export function logEventResultsRelatedCareerClick(data) {
  logEventInstitutionMatcher('62', data);
};

export function logEventResultsBackClick(data) {
  logEventInstitutionMatcher('63', data);
};

export function logEventResultsShareClose() {
  logEventInstitutionMatcher('64');
};

export function logEventResultsShareSocialMedia(data) {
  logEventInstitutionMatcher('65', data);
};

export function logEventResultsShareCopyLink() {
  logEventInstitutionMatcher('66');
};

export function logEventMapRestaurantFilterToggle(data) {
  logEventInstitutionMatcher('67', { filterState: formatFilterStateToggle(data), ...data });
};
